import { cloneElement, ReactElement } from 'react'
import {
  IconLock,
  Link,
  SequenceMenu,
  Tooltip
} from '@sequencehq/core-components'
import { PermissionString } from './types'
import { Protected } from './Protected'

interface Props {
  permission: Array<PermissionString> | PermissionString
  children: ReactElement<typeof SequenceMenu.Item>
  needsEveryPermission?: boolean
  tooltipMessage?: string
  to?: string
}

const PROTECTED_LINK_STYLE = {
  display: 'block',
  color: 'inherit',
  textDecoration: 'none'
} as const

export const ProtectedSequenceMenuItem = ({
  children,
  permission,
  tooltipMessage = "This action isn't available for your current role",
  needsEveryPermission = false,
  to
}: Props) => {
  return (
    <Protected
      permission={permission}
      needsEveryPermission={needsEveryPermission}
    >
      {isAllowed => {
        if (isAllowed && to) {
          return (
            <Link.Unstyled to={to} style={PROTECTED_LINK_STYLE}>
              {children}
            </Link.Unstyled>
          )
        }

        if (isAllowed) {
          return children
        }

        const disabledProps = {
          ...children.props,
          isDisabled: true,
          iconRight: <IconLock color="inherit" />,
          onClick: undefined
          // Had to do it to em, otherwise TS was unhappy bout this guy
        } as unknown as ReactElement<typeof SequenceMenu.Item>['props']

        return (
          <Tooltip label={tooltipMessage}>
            {cloneElement(children, disabledProps)}
          </Tooltip>
        )
      }}
    </Protected>
  )
}
